import React, { createContext, useState } from 'react'

export const ScreenContext = createContext()

const ScreenContextProvider = ({ children }) => {
    const mobile = window.innerWidth < 576
    const tablet = 576 < window.innerWidth && window.innerWidth < 1440
    const desktop = window.innerWidth > 1440
    const [screen, setScreen] = useState(window.innerWidth)

    const updateMedia = () => {
        setScreen(window.innerWidth)
    }
    const contextValues = {
        mobile,
        tablet,
        desktop,
        screen,
        updateMedia,
    }

    return <ScreenContext.Provider value={contextValues}>{children}</ScreenContext.Provider>
}

export default ScreenContextProvider
